import Actions from '../../odata/actions';

const actions = new Actions('delivery', 'deliveries');

export default actions;
